
















































































import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import Store from '@/ts/windows/Store';
import { IBaseAddonInfo } from '@/ts/windows/StoreInfo';

let store!: Store;

@Component
export default class RemoveAds extends Vue {
  private payPalDonationInProgress = false;
  private payPalDonationInCompleted = false;
  private removeAdsAddon: IBaseAddonInfo = {
    formattedPrice: '$1.99',
    storeId: '9P0XWRQQ34B7',
    title: 'Remove ads',
  };
  private removeAdsPlusAddon: IBaseAddonInfo = {
    formattedPrice: '$3.99',
    storeId: '9P7T901M85B0',
    title: 'Remove ads and support the developer',
  };
  private removeAdsPlusPlusAddon: IBaseAddonInfo = {
    formattedPrice: '$9.99',
    storeId: '9MX6RQKF0DFX',
    title: 'Remove ads and support the developer plus',
  };
  private removeAdsFreeAddon: IBaseAddonInfo = {
    formattedPrice: '$0.00',
    storeId: '9MTVJL85WW4Q',
    title: 'Remove ads for free',
  };

  private get isWindows(): boolean {
    return !(window.Windows === undefined);
  }

  private verifyPayPalDonation() {
    this.payPalDonationInProgress = false;
    this.payPalDonationInCompleted = true;
    this.$emit('remove-ads');
  }

  private async removeAds(addonId: string) {
    if (await store.purchaseAddon(addonId)) {
      this.$emit('remove-ads');
    }
  }

  private async created() {
    if (this.isWindows) {
      store = new Store();
      const addonsPurchased = await store.areAnyAddonsPurchased();
      if (addonsPurchased) {
        this.$router.push({name: 'home'});
      } else {
        const addonInfo = await store.getAddonInfo(['9P0XWRQQ34B7', '9P7T901M85B0', '9MX6RQKF0DFX', '9MTVJL85WW4Q']);
        if (addonInfo && addonInfo.length >= 4) {
          this.removeAdsAddon.formattedPrice = addonInfo.find(
            (addon) => addon.storeId === this.removeAdsAddon.storeId)!.formattedPrice;
          this.removeAdsPlusAddon.formattedPrice = addonInfo.find(
            (addon) => addon.storeId === this.removeAdsPlusAddon.storeId)!.formattedPrice;
          this.removeAdsPlusPlusAddon.formattedPrice = addonInfo.find(
            (addon) => addon.storeId === this.removeAdsPlusPlusAddon.storeId)!.formattedPrice;
          this.removeAdsFreeAddon.formattedPrice = addonInfo.find(
            (addon) => addon.storeId === this.removeAdsFreeAddon.storeId)!.formattedPrice;
        }
      }
    }
  }
}
